//
// Generated class QuotationDocument
//

/// <reference path="QuotationDocument_ManagedObject.ts" />

class QuotationDocument extends QuotationDocument_ManagedObject
{

}
